import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "The3DSoftware"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.1177 9.83627L9.36765 6.08627C9.1356 5.95229 8.8497 5.95229 8.61765 6.08627L1.86765 9.83627C1.63496 9.97558 1.49473 10.2289 1.50015 10.5V17.9963C1.50213 18.2684 1.65139 18.5181 1.89015 18.6488L8.64015 22.3988C8.74973 22.4623 8.87355 22.4971 9.00015 22.5C9.12907 22.4967 9.25522 22.4619 9.36765 22.3988L16.1177 18.6488C16.3533 18.5178 16.4996 18.2696 16.5002 18V10.5C16.5025 10.2258 16.3561 9.97176 16.1177 9.83627ZM8.2502 20.4712L3.0002 17.5537V11.7637L8.2502 14.6812V20.4712ZM9.00007 13.3837L3.79507 10.5L9.00007 7.60125L14.2051 10.4962L9.00007 13.3837ZM15.0002 17.5537L9.7502 20.4712V14.6812L15.0002 11.7637V17.5537ZM22.5002 4.5H19.5002V1.5H18.0002V4.5H15.0002V6H18.0002V9H19.5002V6H22.5002V4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/The3DSoftware.vue"]]);
